import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import AssetItemContainer from './AssetItem.styles';

const AssetItem = ({ icon, title, onClick }: { icon: React.ReactNode; title: string; onClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('clickToAdd')}>
      <AssetItemContainer onClick={onClick}>
        {icon}
        <span className="asset-item-title">{t(title)}</span>
      </AssetItemContainer>
    </Tooltip>
  );
};

export default AssetItem;
